<template>
    <div class="dashboard">
        <!-- Sidebar -->
        <!-- <aside class="sidebar" v-if="!isFullScreen">
            <h2 class="logo">Dashboard</h2>
            <nav>
                <ul class="list-unstyled">
                    <li v-if="hasRole(['admin', 'counselor'])">
                        <router-link to="/dashboard">🏠 Home</router-link>
                    </li>
                    <li v-if="hasRole(['admin'])">
                        <router-link to="/dashboard/reports">📊 Reports</router-link>
                    </li>
                    <li>
                        <a v-if="hasRole(['admin'])" href="#" @click.prevent="toggleMenu('manageData')">📂 Manage
                            Data</a>
                        <transition name="slide-fade">
                            <ul v-show="menuState.manageData" class="nested-menu">
                                <li v-if="hasRole(['admin'])"><router-link to="/dashboard/counselors">👩‍⚕️ Manage
                                        Counselors</router-link></li>
                                <li v-if="hasRole(['admin'])"><router-link to="/dashboard/employees">👩‍⚕️ Manage
                                        Employees</router-link></li>
                                <li v-if="hasRole(['admin'])"><router-link to="/dashboard/frontdesk">👩‍⚕️ Manage
                                        FrontDesk Accounts</router-link></li>
                                <li v-if="hasRole(['admin'])"><router-link to="/dashboard/students">👩‍⚕️ Manage
                                        Students</router-link></li>
                                <li v-if="hasRole(['admin'])"><router-link to="/dashboard/days">📅 Manage
                                        Days</router-link>
                                </li>
                                <li v-if="hasRole(['admin'])"><router-link to="/dashboard/time-slots">⏳ Manage Time
                                        Slots</router-link></li>
                                <li v-if="hasRole(['admin'])"><router-link to="/dashboard/groups">👥 Manage
                                        Groups</router-link></li>
                                <li v-if="hasRole(['admin'])"><router-link to="/dashboard/agendas">📅 Manage
                                        Agendas</router-link></li>

                            </ul>
                        </transition>
                    </li>
                    <li v-if="hasRole(['admin'])">
                        <router-link to="/dashboard/timetable-index">📅 Manage Timetable</router-link>
                    </li>
                    <li v-if="hasRole(['admin', 'counselor', 'front desk'])">
                        <router-link to="/dashboard/appointments">📅 Manage Appointments</router-link>
                    </li>
                    <li v-if="hasRole(['admin', 'counselor', 'front desk'])">
                        <router-link to="/dashboard/attendance_dashboard">📋 Attendance Dashboard</router-link>
                    </li>
                    <li v-if="hasRole(['admin', 'counselor', 'front desk'])">
                        <router-link to="/dashboard/attendance">📋 Manage Attendance</router-link>
                    </li>
                    <li>
                        <button class="logout-btn" @click="logout">🚪 Logout</button>
                    </li>
                </ul>
            </nav>
        </aside> -->

        <!-- Main Content -->
        <main class="rounded" :class="isFullScreen ? 'content-full-screen' : 'content'">
            <header class="topbar rounded" v-if="!isFullScreen">
                <h1>Welcome, {{ user.name || 'User' }}</h1>
            </header>
            <DashboardIcons v-if="$route.path === '/dashboard'" />
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </main>
    </div>
</template>

<script>
// import DashboardStats from "@/components/DashboardStats.vue";
import DashboardIcons from "@/components/DashboardIcons.vue";
import emitter from '@/eventBus';

export default {
    components: {
        // DashboardStats,
        DashboardIcons
    },
    data() {
        return {
            user: {
                name: 'User'
            },
            menuState: {
                manageData: false
            }
            ,
            isFullScreen: false
        };
    },
    computed: {
        userRole() {
            return this.$store.state.user.role;
        }
    },
    methods: {
        hasRole(allowedRoles) {
            if (!this.$store.getters.isAuthenticated) {
                return;
            }
            return allowedRoles.includes(this.userRole);
        },
        logout() {
            this.$store.dispatch('logout');
            this.$router.push('/login');
        },
        toggleMenu(menu) {
            this.menuState[menu] = !this.menuState[menu];
        },
        handleToggleFullscreen() {
            this.isFullScreen = this.$store.getters.isFullScreen;
        }
    },
    mounted() {
        if (this.$store.state.user) {
            this.user = this.$store.state.user;
        }
        emitter.on('toggle-fullscreen', this.handleToggleFullscreen);
        this.isFullScreen = this.$store.getters.isFullScreen;
    }
};
</script>

<style scoped>
.dashboard {
    /* display: flex;
    height: 100vh; */
    background: #f4f7fc;
}

.sidebar {
    width: 250px;
    min-height: 100vh;
    background: #222250;
    color: white;
    display: flex;
    flex-direction: column;
    padding: 20px;
    position: fixed;
    left: 0;
    top: 0;
    overflow-y: auto;
}

.sidebar a {
    color: white;
    text-decoration: none;
    display: block;
    padding: 10px;
    border-radius: 5px;
}

.sidebar a:hover {
    background-color: #1DBCBC;
}

.nested-menu {
    padding-left: 20px;
    display: block;
}

.nested-menu li {
    margin: 5px 0;
}

.list-unstyled {
    padding-left: 0;
}

.logo {
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
    font-weight: bold;
}

.sidebar nav ul {
    list-style: none;
    padding: 0;
}

.sidebar nav ul li {
    margin: 15px 0;
}

.sidebar nav ul li a,
.logout-btn {
    color: white;
    text-decoration: none;
    padding: 12px;
    display: block;
    border-radius: 5px;
    transition: 0.3s;
    width: 100%;
    text-align: left;
    background: transparent;
    border: none;
    cursor: pointer;
}

.sidebar nav ul li a:hover,
.logout-btn:hover {
    background: #1DBCBC;
}

.content {
    flex: 1;
    padding: 20px;
    /* margin-left: 250px; */
    margin-bottom: 50px;
    ;
    /* overflow: auto; */
    /* height: 100vh; */
}

.content-full-screen {
    flex: 1;
    padding: 20px;
    /* margin-left: 250px; */
    margin-bottom: 50px;
}

.topbar {
    background: white;
    padding: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
}
</style>
